import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const AdminViewButton = ({ style }) => {
  const navigate = useNavigate();
  const navigateAdmin = () => {
    navigate("/admin");
  };
  return (
    <Button
      variant="contained"
      startIcon={<AdminPanelSettingsIcon />}
      onClick={navigateAdmin}
      style={style}
    >
      Admin
    </Button>
  );
};

export default AdminViewButton;
